import React from 'react';
import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import Input from 'components/Input';
import { ManualNFDevolutionProps } from './interface';

export const NfDevolution: React.FC<ManualNFDevolutionProps> = (props) => {
  const {
    manualDevolutionInvoiceNumber,
    setManualDevolutionInvoiceNumber,
    protocolCategory,
    ticketReason
  } = props;

  const onChangeNfDevolution = (e: string) => {
    setManualDevolutionInvoiceNumber(e);
  };

  return (
    // FINANCEIRO E COMPENSAÇÃO DE NOTA DE CRÉDITO
    protocolCategory === '3' && ticketReason === '43' ?
      (
        <Row className='flex-1 flex-md-column'>
          <Row className="flex-md-column mt-3">
            <Column
              className={'flex-1 max-w-md-100 mt-md-2'}
            >
              <Text className="mb-2 color-blue-gray" size={12}>
                Nº Nota Fiscal de Devolução
              </Text>
              <Input
                id="return-invoice-number"
                stateName="manualDevolutionInvoiceNumber"
                onChange={(e: any) => onChangeNfDevolution(e.target.value)}
                required
                name="Nº Nota Fiscal de Devolução"
                className="w-100"
                type="text"
                value={manualDevolutionInvoiceNumber}
                placeholder="Nº Nota Fiscal de Devolução"
                disabled={false}
              />
            </Column>
          </Row>
        </Row>
      ) : <></>
  );
};
